import './assets/main.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { datadogRum } from '@datadog/browser-rum'
import VueGtagPlugin from 'vue-gtag'
import { PrevioDesignSystem } from '@previo/design-system'
import { i18n, useLocale } from '@previo/core'
import { FeatureFlag } from '@previo/feature-flags'
import { Environment } from '~/Environment'
import { chunkLoadRecovery } from '~/plugins/chunkLoadRecovery'
import messages from '~/locales'
import App from './App.vue'
import router from './router'

const pinia = createPinia()
const app = createApp(App)

useLocale().setMessages(messages)

app.use(pinia)
app.use(i18n)
app.use(router)
app.use(PrevioDesignSystem)
app.use(chunkLoadRecovery)
app.use(
  VueGtagPlugin,
  {
    config: {
      id: import.meta.env.CRM_FE_GOOGLE_ANALYTICS_4_KEY,
    },
  },
  router,
)

app.use(FeatureFlag, {
  clientSideID: import.meta.env.CRM_FE_FF_CLIENT_SIDE_ID,
  contextKind: import.meta.env.CRM_FE_FF_CONTEXT_KIND,
  provider: import.meta.env.CRM_FE_FF_PROVIDER,
})

app.mount('#app')

if (Environment.isEnvLikeProduction()) {
  datadogRum.init({
    applicationId: import.meta.env.CRM_FE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.CRM_FE_DATADOG_CLIENT_TOKEN,
    version: import.meta.env.CRM_FE_APP_VERSION,
    site: 'datadoghq.eu',
    service: 'previo2-crm-fe',
    env: Environment.SELECTED,
    sessionSampleRate: 5,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  })
}
